import React from "react";
import axios from "axios";
import { I18n, Translate } from "react-redux-i18n";
import { config } from "../config";
import "./styles/KindCommerceHome.css";

const url_api = config.api.godiway;

const COMMERCE_TYPES = [
  { key: "sale", kindId: 2 },
  { key: "rent", kindId: 4 },
  { key: "exchange", kindId: 3 },
  { key: "donation", kindId: 1 },
  { key: "auction", kindId: 5 },
];

const EMPTY_COUNTS = {
  sale: 0,
  rent: 0,
  exchange: 0,
  donation: 0,
  auction: 0,
};

class KindCommerceHome extends React.Component {
  state = {
    counts: { ...EMPTY_COUNTS },
    loading: true,
    error: false,
  };

  componentDidMount() {
    this.loadCounts();
  }

  loadCounts = async () => {
    try {
      const response = await axios.get(url_api + "summary/home", {
        params: { lang: I18n.t("locale") },
        validateStatus: (status) => status < 500,
      });

      if (
        response.status < 300 &&
        response.data &&
        response.data.status === "Success" &&
        response.data.body
      ) {
        const body = response.data.body;
        const counts = {};
        COMMERCE_TYPES.forEach(({ key }) => {
          counts[key] = typeof body[key] === "number" ? body[key] : 0;
        });
        this.setState({ counts, loading: false, error: false });
        return;
      }

      this.setState({ loading: false, error: true });
    } catch (error) {
      console.log(error);
      this.setState({ loading: false, error: true });
    }
  };

  formatCount = (value) => {
    if (value === null || value === undefined) return "—";
    return value.toLocaleString(I18n.t("locale"));
  };

  render() {
    return (
      <div className="container-kindcommerce">
        {COMMERCE_TYPES.map(({ key }) => (
          <div key={key} className="kindcommerce-stat" align="center">
            <div className="kindcommerce-stat-count">
              {this.state.loading ? "…" : this.formatCount(this.state.counts[key])}
            </div>
            <p className="kindcommerce-stat-products">
              <Translate value="products" />
            </p>
            <h4>
              <Translate value={key} />
            </h4>
          </div>
        ))}
      </div>
    );
  }
}

export default KindCommerceHome;
